<template>
  <v-container
    v-if="noteVisible"
    fluid
    class="note-container"
    :style="{backgroundColor: '#' + ContentColor, border: '1px solid #' + borderColor}">
    <v-row align="start" justify="start" class="px-2">
      <v-col justify="start" align="start" class="shrink py-0">
        <v-icon size="24">mdi-information</v-icon>
      </v-col>
      <v-col class="grow py-0 pl-1">
        <slot />
        <div v-if="permenant_dismiss !== false" class="mt-2">
          <label class="dnt-shw-label" for="dnt-shw-agn">
          <input type="checkbox" id="dnt-shw-agn" v-model="dontShowNoteAgain" @change="preventShowingNoteAgain">
            Don't show me this again
          </label>
        </div>
      </v-col>
      <v-col v-if="dismissable !== false" justify="start" align="start" class="shrink py-0">
        <v-icon @click="closeNote">mdi-close</v-icon>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Note',
  props: ['dismissable', 'permenant_dismiss', 'note_id', 'type'],
  data () {
    return {
      noteVisible: true,
      dontShowNoteAgain: false
    }
  },
  computed: {
    borderColor () {
      switch(this.type){
      case "info": return '010d59'
      case "error": return '9e1313'
      default: return '9e1313'
      }
    },
    ContentColor () {
      switch(this.type){
      case "info": return 'fffdb9'
      case "error": return 'e77676'
      default: return 'e77676'
      }
    }
  },
  methods: {
    closeNote () {
      this.noteVisible = false
    },
    preventShowingNoteAgain () {
      if (this.dontShowNoteAgain) {
        localStorage.setItem(this.note_id, true)
      } else {
        localStorage.removeItem(this.note_id)
      }
    }
  },
  beforeMount () {
    if (localStorage.getItem(this.note_id)) {
      this.noteVisible = false
    }
  }
}
</script>

<style scoped>
.note-container{
  border-radius: 4px;
}
.dnt-shw-label {
  vertical-align: middle;
  color: grey;
  font-size: 12px;
}
#dnt-shw-agn {
 vertical-align: middle
}
</style>
